import styled from 'styled-components';
import { Text } from '@blueprism/ui-core';

export const TextWrapped = styled(Text)`
  word-break: break-word;
`;
